import React, { useContext, useState } from 'react'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import TimeWindowSelectorButton from '../../../elem/chart/TimeWindowSelectorButton'
import ResetZoomButton from '../../../elem/chart/ResetZoomButton'
import SaveAsImageButton from '../../../elem/chart/SaveAsImageButton'
import { AppStateContext } from '../AppStateContext'
import CollapseButton from '../../../elem/list/CollapseButton'

const AggregateHeader = ({ chartRef, isCollapsed, setCollapsed }) => {
    const {
        timeWindow,
        displayTimeWindowDropdown,
        toggleTimeWindowDropdown,
        loading,
        tooManyFeatures,
        resetZoom,
    } = useContext(DataContext)
    const {
        mapState: { selectedFeatures },
    } = useContext(AppStateContext)

    return (
        <PanelHeader extraClass={'aggregatePanelHeader'}>
            <div className="panelHeaderText">Aggregate Nitrate Chart</div>
            <div className="panelButtons">
                <SaveAsImageButton
                    name={'AggregateNitrateChart'}
                    componentRef={chartRef}
                    disabled={
                        loading || tooManyFeatures || !selectedFeatures.length
                    }
                />
                <ResetZoomButton resetFunction={resetZoom} />
                <TimeWindowSelectorButton
                    timeWindow={timeWindow}
                    displayTimeWindowDropdown={displayTimeWindowDropdown}
                    toggleTimeWindowDropdown={toggleTimeWindowDropdown}
                />
                <CollapseButton
                    name={`aggregate`}
                    isCollapsed={isCollapsed}
                    setIsCollapsed={setCollapsed}
                />
            </div>
        </PanelHeader>
    )
}

export default AggregateHeader
